/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';

/**
 * @class Defines a hotspot question.
 */
export class InternetPageContentModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a hotspot question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.url = bo.url;
  }
}
